import { apiGet, apiPost } from './client';

// 권위: docs/ARCH_DASHBOARD.md §4.5 "수동 Circuit Breaker" + §6.2 시스템 제어 API.
// dashboard-api 에이전트가 `POST /api/v1/system/circuit-breaker/manual-trigger` 를 병렬 구현 중.
// - 서버는 `GOVERNANCE.MANUAL.CB_TRIGGERED` FATAL SystemEvent 를 자동 발행하며,
//   응답으로 event_id / triggered_at / triggered_by / action 을 돌려준다.
// - 클라이언트 측은 단순히 래핑만. envelope 언랩은 apiPost 헬퍼가 담당.

export type ManualCircuitBreakerAction =
  | 'HALT_NEW_ORDERS'
  | 'REDUCE_ALL_50PCT'
  | 'HALT_ALL';

export interface ManualCircuitBreakerRequest {
  action: ManualCircuitBreakerAction;
  reason: string;
  confirmToken?: string;
}

export interface ManualCircuitBreakerResponse {
  triggeredAt: string;       // ISO-8601
  triggeredBy: string;       // 조작자 email
  action: ManualCircuitBreakerAction;
  eventId: string;           // GOVERNANCE.MANUAL.CB_TRIGGERED 이벤트 UUID
}

export interface CircuitBreakerState {
  status: 'NORMAL' | 'HALT_NEW_ORDERS' | 'REDUCE_ALL_50PCT' | 'HALT_ALL';
  lastTriggeredAt: string | null;
  lastTriggeredBy: string | null;
  reason: string | null;
}

/**
 * 운영자가 직접 Circuit Breaker 를 발동한다. 확인 모달에서 2단계 체크 + reason 10자 이상 필수.
 * 성공 시 서버는 즉시 GOVERNANCE.MANUAL.CB_TRIGGERED (FATAL) 이벤트를 브로드캐스트 → Live Monitor
 * 좌측 이벤트 스트림이 즉시 반영.
 */
export function triggerManualCircuitBreaker(
  action: ManualCircuitBreakerAction,
  reason: string,
  confirmToken?: string
): Promise<ManualCircuitBreakerResponse> {
  const body: ManualCircuitBreakerRequest = { action, reason };
  if (confirmToken) body.confirmToken = confirmToken;
  return apiPost<ManualCircuitBreakerResponse>(
    '/api/v1/system/circuit-breaker/manual-trigger',
    body
  );
}

/** (선택) 현재 상태 조회 — GET /api/v1/system/circuit-breaker */
export function getCircuitBreakerState(): Promise<CircuitBreakerState> {
  return apiGet<CircuitBreakerState>('/api/v1/system/circuit-breaker');
}
